(function () {
    'use strict';

    angular
        .module('app.ics')
        .controller('TipController', TipController);

    TipController.$inject = ['$scope', 'close', '$timeout'];

    function TipController($scope, close, $timeout) {
        var vm = this;

        vm.gotIt = function(){
            close(true, 500);
        };
    }
})();
